import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import './CoursesSelection.scss'
const CoursesSelection = () => {
    
    const [selectedCourses,setSelectedCourses] = useState([]);
    const userInfo = useSelector( state => state.user );


    const selectCourse =(cr)=>{
        if(!isItemFound(cr)){
            selectedCourses.push(cr)
        }else{
            selectedCourses.forEach((el,index)=> {
                if(el._id === cr._id){
                    selectedCourses.splice(index,1);
                }
            });
        }
        console.debug(selectedCourses)
        setSelectedCourses([...selectedCourses]);
    }

    const isItemFound = (item)=>{
        const found = selectedCourses.filter((cr)=>{
            return cr._id === item._id 
        })

        if(found.length > 0){
            return true
        }
        return false;
    }

    const courseAssignment = ()=>{
        // {"userid":"620a259f0de9c5349703a683","assignedcourses":["6225cfa69f02e9503f6bc596"],"assignedby":"620a1f040de9c5349703a63f"}
    }

    const isCourseSelected = (cr)=>{
        return isItemFound(cr);
    }

    return <div className="course-assignment">
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <ul className="all-courses-list">
                    {userInfo?.allCourses.length > 0 && userInfo?.allCourses.map((cr)=>{
                            return <li className={isCourseSelected(cr) ? 'selected' :'non-selected'  } key={cr._id} onClick={()=>selectCourse(cr)}>{cr?.coursename}</li>
                    })}
                </ul>
                <div className="btn-items">
                        <button type="submit" className="btn btn-assign" 
                        onClick={()=>courseAssignment()} disabled={selectedCourses.length === 0}> Add </button>
                        <button type="submit" className="btn btn-cancel" > Cancel </button>
                </div>
            </div>
        </div>
    </div>
}

export default CoursesSelection